import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TerminalDto } from '@app/data/dtos/tpv/terminal.dto';

/** DTO de terminal -> entidad de dominio (id_merchant -> externalIdMerchant). */
export function mapTerminal(dto: TerminalDto): TpvTerminal {
  return {
    idTerminal: dto.id_terminal,
    externalIdMerchant: dto.id_merchant ?? '',
    companyName: dto.company_name ?? '',
    merchantName: dto.merchant_name ?? '',
    affiliation: dto.affiliation ?? '',
    os: dto.os ?? '',
    lastActivity: dto.last_activity ?? '',
    status: dto.status ?? '',
    name: dto.name ?? '',
    model: dto.model ?? '',
    brand: dto.brand ?? '',
    versionApp: dto.version_app ?? '',
  };
}
